import React, { useState, useEffect, useRef } from 'react';
import { Button } from '@mui/material';



const CheckCameraWidget = ({ onStateChange, refv }) => {
    
    //const videoRef = useRef(null);
    const [err, setErr] = React.useState(null); 
    const [continueButton, setContinueButton] = React.useState(false); 
  

    function checkCamera(){
        navigator.mediaDevices
          .getUserMedia({ video: true, audio: true })
          .then((stream) => {
            // Установка видеопотока в элемент <video>
            if (refv.current) {
              refv.current.srcObject = stream;
            }
            setContinueButton(true)
          })
          .catch((error) => {
            console.log('Ошибка при получении доступа к камере/микрофону:', error);
            setErr('Ошибка при получении доступа к камере/микрофону.' + error)
            setContinueButton(false)
          });
    }



    function nextButtonClick(){
        
        // Остановка видеопотока 
        if (refv.current) {
            const stream = refv.current.srcObject;
            if (stream) {
            const tracks = stream.getTracks();
            tracks.forEach((track) => track.stop());
            }
        }

        onStateChange(continueButton); // Вызываем функцию обратного вызова
    }

      
    
    return (
      <div style={{padding: '18px'}}>
        
        <h2>{}Проверка камеры</h2>


        <p style={{color:'red'}}>{err}</p>
        
        {
            continueButton ===false ? 
            <>
                <button onClick={checkCamera}>Включить камеру</button>
                <br/>  <br/> 
            </>: <></>
        }
        
        
        <video style={{objectFit: 'cover',  height: '100px'}} ref={refv} autoPlay playsInline muted />
        

        {
            continueButton ? 
            <>
            <br/>    <br/> 
            <Button  
            onClick={nextButtonClick}
            variant="contained"  sx={{ borderRadius: '16px',  background: 'green', minWidth: '150px'}}>
                Далее
            </Button>
            </>
       
            : <></>

        }
        
        
      </div>
    );
  };


  export default CheckCameraWidget;
